export const MAX_SIZE_BYTES_FOR_SCREENCAST = 25 * 1024 * 1024;
